<template>
    <div style="height: 90vh;">
        <v-layout justify-center row fill-height align-center>
            <v-flex md8>
                <slot name="media">
                    <v-img
                            style="margin: 0 auto;"
                            width="300"
                            height="200"
                            :src="require('@/assets/img/analytics.svg')">
                    </v-img>
                </slot>
                <h2 class="mt-5 mb-4 text-xs-center display-1 font-weight-medium monitor-title--color">
                    <slot name="title">Discover your brand's audience here!</slot>
                </h2>
                <p class="text-xs-center info--color info-about font-weight-medium">
                    <slot name="msg">You don't have access to this feature at the moment.</slot><br/>
                    <slot name="body">
                        Please contact <a class="info--color font-weight-bold" href="mailto:customersuccess@bindez.com">customersuccess@bindez.com</a> or call <span class="font-weight-bold">+959404060860</span>
                    </slot>
                </p>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
	export default {
		name: "AudienceNotAvailable"
	}
</script>

<style scoped>
    .info--color {
        color: #5e7582;
    }

    p.info-about{
        font-size: 20px;
        line-height: 2rem;
    }

    p.info-about a {
        text-decoration: none;
        cursor: pointer;
    }
</style>
